<template>
    <div class="layout1-agent-card">
        <div class="layout1-avatar-box">
            <a
                class="avatar-box-a"
                :href="redirectUrl"
                :target="detailUrlTarget"
                rel="noopener noreferrer"
            >
                <img
                    :src="agentTargetImage"
                    class="avatar"
                    :alt="agent.fullName || 'agent image'"
                    errorImg="https://cdn.chime.me/image/fs/sitebuild/202457/7/original_fbb918b4-831d-43d3-8d96-68f8986a8e79.png"
                />
            </a>
            <Share
                v-if="agent.agentSocialNetworks.length"
                :socialNetworks="agent.agentSocialNetworks"
                :theme="'layout1'"
            />
        </div>
        <div class="agent-info">
            <h5 v-if="agent.fullName">{{ agent.fullName }}</h5>
            <p v-if="agent.position">{{ agent.position }}</p>
        </div>
    </div>
</template>

<script>
import agentInfo from '../agent-info';
import Share from '../_components/share';
export default {
    props: {
        agent: {
            type: Object,
            required: true
        },
        detailUrlTarget: {
            type: String,
            default: '_self'
        }
    },
    components: { Share },
    mixins: [agentInfo]
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.layout1-agent-card {
    width: 100%;
    .layout1-avatar-box {
        width: 100%;
        aspect-ratio: 1;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        a.avatar-box-a {
            display: block;
            width: 100%;
            aspect-ratio: 1;
            overflow: hidden;
            position: relative;
        }
    }
    .avatar {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
        // transition: transform 0.3s ease;
        position: relative;
        overflow: hidden;
        vertical-align: middle;
        cursor: pointer;
    }
    .share-links {
        position: absolute;
        bottom: 0;
        width: 100%;
        text-align: center;
        padding: 85px 0px 30px;
        background: linear-gradient(
            180deg,
            rgba(25, 25, 25, 0) 10%,
            rgba(25, 25, 25, 0.9) 100%
        );
        display: none;
        @include media-600 {
            display: block;
            padding-bottom: 20px;
        }
        .iconfont {
            margin-right: 15px;
            background: transparent;
            @include media-600 {
                margin-right: 10px;
                font-size: 12px;
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }

    &:hover {
        .share-links {
            display: block;
        }
    }
    .agent-info {
        margin-top: 18px;
        text-align: center;
        h5 {
            font-size: 20px;
            line-height: 30px;
            font-weight: 500;
            font-family: var(--font-normal);
            color: var(--g-primary-color);
            margin: 0;
        }
        p {
            margin-top: 2px;
            font-size: 14px;
            line-height: 24px;
            font-family: var(--font-normal);
            color: var(--g-text-color);
            font-weight: 400;
        }
    }

    @include media-600 {
        .share-links {
            display: block;
            position: absolute;
        }
        .agent-info {
            margin-top: 10px;
            h5 {
                font-size: 16px;
                line-height: 30px;
            }
            p {
                font-size: 14px;
                line-height: 24px;
            }
        }
    }
}
</style>
